import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import Switch from '../../../components/ToggleSwitch';
import Spin from '../../../components/loading';
import ImageUploader from '../../../components/imageUploader';
import ShowForPermission from '../../../components/ShowForPermission';
import * as userActions from '../../../redux/users/actions';
import * as rolesActions from '../../../redux/roles/actions';
import * as cafeActions from '../../../redux/cafes/actions';
import {
  formatter,
  domManipulator,
  validator,
  enumHelper,
} from '../../../utils';
import '../userManagement.scss';
import ENUMS from '../../../enums';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class AddOrEditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      isChangedPanelPassword: null,
      firstName: '',
      avatarFileName: '',
      avatarUrl: '',
      roleId: null,
      lastName: '',
      userName: '',
      gender: '',
      maritalStatus: '',
      birthDate: ' ',
      marriageDate: ' ',
      mobileNumber: '',
      credit: null,
      currency: '',
      enabled: true,
      errorText: locales('errors.default'),
      errorFlag: false,
      checked: true,
      isMarried: false,
      loaded: false,
      panelPassword: '',
      confirmPanelPassword: "",
      userNameInputInvalidMessage: '',
      userNameInputValidStatus: '',
      panelPasswordInputInvalidMessage: '',
      panelPasswordInputValidStatus: '',
      confirmPanelPasswordInputValidStatus: '',
      confirmPanelPasswordInputInvalidMessage: '',
      firstNameInputInvalidMessage: '',
      firstNameInputValidStatus: '',
      lastNameInputInvalidMessage: '',
      lastNameInputValidStatus: '',
      mobileNumberInputInvalidMessage: '',
      mobileNumberInputValidStatus: '',
      statusInputInvalidMessage: '',
      statusInputValidStatus: '',
      confirmCafeIdNotSelectedMessage: '',
      confirmCafeIdNotSelectedStatus: '',

      cafeId: null,
    };
  }

  formReference = React.createRef();
  alertRef = React.createRef();
  statusRef = React.createRef();

  componentDidUpdate(_, prevState) {
    if (
      this.props.location.editMode &&
      prevState.loaded == false &&
      Object.entries(this.props.userDetails).length
    ) {
      let {
        status,
        avatarUrl,
        firstName,
        roleId,
        lastName,
        isChangedPanelPassword = false,
        avatarFileName,
        userName,
        gender,
        maritalStatus,
        birthDate,
        marriageDate,
        mobileNumber,
        credit,
        currency,
        cafeId,
      } = this.props.userDetails;

      this.setState(
        {
          status,
          avatarUrl,
          firstName,
          avatarFileName,
          lastName,
          roleId,
          userName,
          gender,
          maritalStatus,
          birthDate,
          marriageDate,
          isChangedPanelPassword,
          mobileNumber,
          credit,
          currency,
          cafeId,
          loaded: true,
          panelPassword: 'undefined',
          confirmPanelPassword: "undefined",
        },
        () => {
          Array.from(this.formReference.current).forEach(element => {
            if (
              element.name &&
              element.name.length &&
              element.type !== 'file'
            ) {
              element.value = this.state[element.name];
            }
            if (element.name === 'status' || element.id == 'status') {
              element.value = status;
              this.statusRef.current.value = status;
            }
          });
        },
      );
    }
  }

  componentDidMount() {
    this.props.getAllCafeNamesForPanel();
    this.props.fetchAllRoles();
    if (this.props.location.editMode) {
      this.props.fetchUserById(this.props.location.userId);
    }
  }

  validateForm = () => {
    return new Promise(resolve => {
      let formObject = {};
      let formattedStatus;
      Array.from(this.formReference.current).forEach(element => {
        if (element.name && element.name.length)
          formObject[
            `formatted${element.name[0].toUpperCase() + element.name.slice(1)}`
          ] = formatter.toStandard(element.value);
        formattedStatus = this.statusRef.current.value;
      });

      let isFirstNameValid,
        isLastNameValid,
        isStatusValid,
        isUserNameValid,
        isMobileNumberValid,
        isPanelPasswordValid,
        isConfirmPanelPasswordValid,
        isCafeIdValid,
        firstErrorElementId = '',
        errors = {};

      let {
        formattedFirstName,
        formattedLastName,
        formattedUserName,
        formattedPanelPassword,
        formattedConfirmPanelPassword,
        formattedMobileNumber,
      } = formObject;

      if (!formattedUserName) {
        errors.userNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('messages.username'),
          },
        );
        errors.userNameInputValidStatus = 'is-invalid';
        firstErrorElementId = 'userName';
        isUserNameValid = false;
      } else {
        errors.userNameInputInvalidMessage = '';
        errors.userNameInputValidStatus = '';
        isUserNameValid = true;
      }

      if (!formattedMobileNumber) {
        errors.mobileNumberInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('tables.financial.transaction.userMobileNumber'),
          },
        );
        errors.mobileNumberInputValidStatus = 'is-invalid';
        firstErrorElementId = 'mobileNumber';
        isMobileNumberValid = false;
      } else {
        if (!validator.isMobileNumber(formattedMobileNumber)) {
          errors.mobileNumberInputInvalidMessage = locales(
            'labels.invalidMobileNumber',
          );
          errors.mobileNumberInputValidStatus = 'is-invalid';
          firstErrorElementId = 'mobileNumber';
          isMobileNumberValid = false;
        } else {
          errors.mobileNumberInputInvalidMessage = '';
          errors.mobileNumberInputValidStatus = '';
          isMobileNumberValid = true;
        }
      }

      if (!formattedStatus) {
        errors.statusInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('tables.status'),
          },
        );
        errors.statusInputValidStatus = 'is-invalid';
        firstErrorElementId = 'status';
        isStatusValid = false;
      } else {
        errors.statusInputInvalidMessage = '';
        errors.statusInputValidStatus = '';
        isStatusValid = true;
      }

      if (!formattedLastName) {
        errors.lastNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('titles.lastName'),
          },
        );
        errors.lastNameInputValidStatus = 'is-invalid';
        firstErrorElementId = 'lastName';
        isLastNameValid = false;
      } else {
        errors.lastNameInputInvalidMessage = '';
        errors.lastNameInputValidStatus = '';
        isLastNameValid = true;
      }

      if (!formattedFirstName) {
        errors.firstNameInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('tables.financial.transaction.userFullName'),
          },
        );
        errors.firstNameInputValidStatus = 'is-invalid';
        firstErrorElementId = 'firstName';
        isFirstNameValid = false;
      } else {
        errors.firstNameInputInvalidMessage = '';
        errors.firstNameInputValidStatus = '';
        isFirstNameValid = true;
      }

      if (!formattedPanelPassword) {
        errors.panelPasswordInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('titles.newPassword'),
          },
        );
        errors.panelPasswordInputValidStatus = 'is-invalid';
        firstErrorElementId = 'panelPassword';
        isPanelPasswordValid = false;
      } else {
        errors.panelPasswordInputInvalidMessage = '';
        errors.panelPasswordInputValidStatus = '';
        isPanelPasswordValid = true;
      }

      if (!formattedConfirmPanelPassword) {
        errors.confirmPanelPasswordInputInvalidMessage = locales(
          'messages.fieldValueIsRequired',
          {
            fieldName: locales('messages.password'),
          },
        );
        errors.confirmPanelPasswordInputValidStatus = 'is-invalid';
        firstErrorElementId = 'confirmPanelPassword';
        isConfirmPanelPasswordValid = false;
      } else {
        errors.confirmPanelPasswordInputInvalidMessage = '';
        errors.confirmPanelPasswordInputValidStatus = '';
        isConfirmPanelPasswordValid = true;
      }

      if (this.state.roleId === 2 || this.state.roleId === 3) {
        console.log(this.state.roleId);
        console.log(this.state.cafeId);
        if (this.state.cafeId) {
          isCafeIdValid = true;
        } else {
          errors.confirmCafeIdNotSelectedMessage = locales(
            'messages.fieldValueIsRequired',
            {
              fieldName: locales('messages.cafeName'),
            },
          );
          errors.confirmCafeIdNotSelectedStatus = 'is-invalid';
          isCafeIdValid = false;
        }
      } else {
        isCafeIdValid = true;
      }

      if (formattedConfirmPanelPassword !== formattedPanelPassword) {
        this.setState({
          errorFlag: true,
          alertColor: 'alert-danger',
          errorText: locales('alerts.PasswordsNotMatch'),
        });
      }

      let isFormValid =
        isUserNameValid &&
        isFirstNameValid &&
        isLastNameValid &&
        isStatusValid &&
        isMobileNumberValid &&
        isPanelPasswordValid &&
        isConfirmPanelPasswordValid &&
        isCafeIdValid &&
        formattedPanelPassword === formattedConfirmPanelPassword;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors,
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          },
        );
      } else {
        resolve(true);
      }
    });
  };

  onSubmit = async event => {
    event.preventDefault();
    const isFormValid = await this.validateForm();
    if (!isFormValid) return;
    let userObject = {};
    Array.from(this.formReference.current).forEach(element => {
      if ((element.name || element.id) && element.value) {
        userObject[element.name] = element.value;
      } else {
        userObject.avatarUrl = this.state.avatarUrl;
        userObject.avatarFileName = this.state.avatarFileName;
      }
    });

    if (!userObject.status) {
      userObject.status = this.props.userDetails.status;
    }
    if (!userObject.gender) {
      userObject.gender = this.props.userDetails.gender;
    }
    if (!userObject.maritalStatus) {
      userObject.maritalStatus = this.props.userDetails.maritalStatus;
    }
    if (
      !userObject.marriageDate &&
      userObject.maritalStatus === ENUMS.MARRIAGE_STATUS.values.COUPLE
    ) {
      userObject.marriageDate = this.props.userDetails.marriageDate;
    }
    if (!userObject.roleId) {
      userObject.roleId = this.props.userDetails.roleId;
    }
    if (!userObject.cafeId) {
      if (userObject.roleId == 2 || userObject.roleId == 3) {
        userObject.cafeId = this.props.userDetails.cafeId;
      }
    }

    if (this.props.location.editMode) {
      userObject.isChangedPanelPassword = this.state.isChangedPanelPassword;
      userObject.id = this.props.location.userId;
      userObject.currency = this.props.userDetails.currency;
      userObject.credit = this.props.userDetails.credit;
      this.props.updateUser(userObject).then(() => {
        let {
          updateUserError,
          updateUserFailed,
          updateUserMessage,
        } = this.props;
        if (
          updateUserError == false &&
          updateUserMessage == null &&
          updateUserFailed == false
        ) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success',
          });
          setTimeout(() => {
            this.props.history.push('/users');
          }, 3000);
        }
      });
    } else {
      this.props.createNewUser(userObject).then(() => {
        let { message, error, failed } = this.props;
        if (message == null && failed == false && error == false) {
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessfully'),
            text: '',
            type: 'success',
          });
          setTimeout(() => {
            this.props.history.push('/users');
          }, 3000);
        }
      });
    }
  };

  deleteAvatar = _ => {
    this.setState(() => ({
      avatarUrl: null,
      avatarFileName: null,
    }));
  };

  onUploadAvatarSuccess = uploadedFile => {
    this.setState(() => ({
      avatarFileName: uploadedFile.fileName,
      avatarUrl: uploadedFile.url,
    }));
  };

  handleSwitchChange = checked => {
    this.setState({ checked, isChangedPanelPassword: !checked });
    if (checked) {
      this.setState({ panelPassword: "undefined", confirmPanelPassword: "undefined" });
    } else {
      this.setState({ panelPassword: "", confirmPanelPassword: "" });
    }
  };

  setMobileNumber = event => {
    const mobileNumber = event.target.value;

    if (validator.isMobileNumber(mobileNumber, { typing: true })) {
      this.setState({ mobileNumber });
    }
  };

  setPanelPassword = event => {
    const panelPassword = event.target.value;
    this.setState({ panelPassword });
  }

  setConfirmPanelPassword = event => {
    const confirmPanelPassword = event.target.value;
    this.setState({ confirmPanelPassword });
  }

  setMarriageDate = val => {
    const marriageDate = val;

    this.setState({
      marriageDate,
      marriageDateValidateStatus: '',
      marriageDateInvalidMessage: '',
    });
  };

  setBirthDate = val => {
    this.setState({
      birthDate: val,
      birthDateValidateStatus: '',
      birthDateInvalidMessage: '',
    });
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  handleSelectedCafeRole = cafeRole => {
    this.setState({ roleId: cafeRole.value });
  };

  render() {
    let {
      checked,
      enabled,
      isMarried,
      firstNameInputValidStatus,
      firstNameInputInvalidMessage,
      lastNameInputValidStatus,
      lastNameInputInvalidMessage,
      statusInputInvalidMessage,
      statusInputValidStatus,
      panelPasswordInputInvalidMessage,
      panelPasswordInputValidStatus,
      confirmPanelPasswordInputInvalidMessage,
      confirmPanelPasswordInputValidStatus,
      mobileNumberInputInvalidMessage,
      mobileNumberInputValidStatus,
      userNameInputInvalidMessage,
      userNameInputValidStatus,
      panelPassword,
      confirmPanelPassword,
      confirmCafeIdNotSelectedMessage,
      confirmCafeIdNotSelectedStatus,

      mobileNumber,

      roleId,
      status,
      gender,
      maritalStatus,
    } = this.state;

    let {
      error,
      failed,
      message,
      loading,

      userDetailsLoading,
      userDetailsFailed,
      userDetailsError,
      userDetailsMessage,
      userDetails,

      rolesLoading,
      rolesFailed,
      rolesError,
      rolesMessage,
      rolesList,

      updateUserLoading,
      updateUserFailed,
      updateUserError,
      updateUserMessage,
    } = this.props;

    return (
      <Spin
        spinning={
          loading || userDetailsLoading || updateUserLoading || rolesLoading
        }
      >
        <section className='page-header'>
          <h1>{locales('titles.usersManagement')}</h1>
          <div className='form-actions'>
            <button onClick={this.onSubmit} className='btn btn-success w-5'>
              <i className='fa fa-save' />
              {locales('labels.save')}
            </button>
            <Link to='/users' className='btn btn-default w-5'>
              <i className='fa fa-reply' />
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>
        <section className='panel panel-default'>
          <div className='panel-heading'>
            {this.props.location.editMode
              ? locales('labels.editUser')
              : locales('labels.addNewUser')}
          </div>
          <div className='panel-body'>
            {this.state.errorFlag && this.handleAlert()}
            {(error || userDetailsError || updateUserError || rolesError) && (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            )}
            {(failed ||
              userDetailsFailed ||
              updateUserFailed ||
              rolesFailed) && (
                <div className='alert alert-danger'>
                  {message ||
                    userDetailsMessage ||
                    updateUserMessage ||
                    rolesMessage}
                </div>
              )}
            <form ref={this.formReference} className='col-12 p-0'>
              <div className='row'>
                <div className='col-lg-9 col-md-9 col-sm-12'>
                  <div className='row px-2 my-4'>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='firstName'
                      >
                        {locales('modal.user.full.name')}
                      </label>
                      <input
                        type='text'
                        id='firstName'
                        name='firstName'
                        className={`form-control col-12 ${firstNameInputValidStatus}`}
                        placeholder={locales('modal.user.full.name')}
                        maxLength={ENUMS.MAX_LENGTH.firstName}
                      />
                      <div className='invalid-feedback'>
                        {firstNameInputInvalidMessage}
                      </div>
                    </div>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='lastName'
                      >
                        {locales('titles.lastName')}
                      </label>
                      <input
                        type='text'
                        id='lastName'
                        name='lastName'
                        className={`form-control col-12 ${lastNameInputValidStatus}`}
                        placeholder={locales('titles.lastName')}
                        maxLength={ENUMS.MAX_LENGTH.lastName}
                      />
                      <div className='invalid-feedback'>
                        {lastNameInputInvalidMessage}
                      </div>
                    </div>
                  </div>
                  <div className='row px-2 my-4'>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='gender'
                      >
                        {locales('titles.gender')}
                      </label>
                      <Select
                        placeholder={
                          gender
                            ? enumHelper.convertEnumValueToTitle(
                              ENUMS.GENDERS.list,
                              gender,
                            )
                            : locales('titles.gender')
                        }
                        isMulti={false}
                        name='gender'
                        id='gender'
                        options={ENUMS.GENDERS.list.map(x => ({
                          value: x.value,
                          label: x.title,
                        }))}
                        className='col-12 p-0 rounded'
                      />
                    </div>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='birthDate'
                      >
                        {locales('titles.birthDate')}
                      </label>
                      <DatePicker
                        marge={true}
                        // placeholder={this.state.birthDate ? this.state.birthDate : locales('fields.selectDate')}
                        id='birthDate'
                        name='birthDate'
                        className='col-12 p-0 date-picker-input birthDate border rounded py-2'
                        onChange={val => this.setBirthDate(val)}
                        value={this.state.birthDate}
                      />
                    </div>
                  </div>
                  <div className='row px-2 my-4'>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='maritalStatus'
                      >
                        {locales('titles.marriageStatus')}
                      </label>
                      <Select
                        placeholder={
                          maritalStatus
                            ? enumHelper.convertEnumValueToTitle(
                              ENUMS.MARRIAGE_STATUS.list,
                              this.state.maritalStatus,
                            )
                            : locales('titles.marriageStatus')
                        }
                        isMulti={false}
                        name='maritalStatus'
                        id='maritalStatus'
                        onChange={marriageStatus => {
                          this.setState({
                            maritalStatus: marriageStatus.value,
                          });
                          this.setState({
                            isMarried:
                              marriageStatus.value == 'MARRIED' ? true : false,
                          });
                        }}
                        options={ENUMS.MARRIAGE_STATUS.list.map(x => ({
                          value: x.value,
                          label: x.title,
                        }))}
                        className='col-12 p-0'
                      />
                    </div>
                    {isMarried || maritalStatus == 'MARRIED' ? (
                      <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1'>
                        <label
                          className='rsee-form-label d-flex col-12'
                          htmlFor='marriageDate'
                        >
                          {locales('titles.marriageDate')}
                        </label>
                        <DatePicker
                          marge={true}
                          placeholder='تاریخ ازدواج'
                          id='marriageDate'
                          name='marriageDate'
                          className='col-12 p-0 date-picker-input marriageDate border rounded py-2'
                          onChange={val => this.setMarriageDate(val)}
                          value={this.state.marriageDate}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className='row px-2 my-4'>
                    <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                      <label
                        className='rsee-form-label d-flex col-12'
                        htmlFor='status'
                      >
                        {locales('tables.status')}
                      </label>
                      <Select
                        onChange={selected =>
                          (this.statusRef.current.value = selected.value)
                        }
                        ref={this.statusRef}
                        placeholder={
                          status
                            ? enumHelper.convertEnumValueToTitle(
                              ENUMS.USER_STATUS.list,
                              status,
                            )
                            : locales('tables.status')
                        }
                        isMulti={false}
                        name='status'
                        id='status'
                        options={ENUMS.USER_STATUS.list.map(x => ({
                          value: x.value,
                          label: x.title,
                        }))}
                        className={`col-12 p-0 rc-dropdown ${statusInputValidStatus}`}
                      />
                      <div className='invalid-feedback'>
                        {statusInputInvalidMessage}
                      </div>
                    </div>
                    <ShowForPermission
                      permission={ENUMS.PERMISSIONS.values.VIEW_ROLES_LIST}
                    >
                      <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                        <label
                          className='rsee-form-label d-flex col-12'
                          htmlFor='status'
                        >
                          {locales('tables.roles')}
                        </label>
                        <Select
                          placeholder={
                            roleId
                              ? rolesList &&
                              rolesList.length &&
                              rolesList.find(item => item.id == roleId).title
                              : locales('tables.roles')
                          }
                          isMulti={false}
                          name='roleId'
                          id='roleId'
                          options={rolesList.map(x => ({
                            value: x.id,
                            label: x.title,
                          }))}
                          className={`col-12 p-0 rc-dropdown`}
                          onChange={selected =>
                            this.handleSelectedCafeRole(selected)
                          }
                        />
                      </div>
                      <div className='col-lg-5 col-md-5 col-sm-0 p-0 m-1 ' />
                      {(this.state.roleId === 2 || this.state.roleId === 3 || this.state.roleId === 9) && (
                        <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                          <label
                            className='rsee-form-label d-flex col-12'
                            htmlFor='status'
                          >
                            {locales('fields.cafe.name')}
                          </label>
                          <Select
                            id='cafeId'
                            name='cafeId'
                            initValue={this.state.cafeId}
                            onChange={selectedCafeId => {
                              this.setState({ cafeId: selectedCafeId.value });
                            }}
                            className={`col-12 p-0 rc-dropdown ${confirmCafeIdNotSelectedStatus}`}
                            options={this.props.cafeNamesList.map(n => ({
                              label: n.name,
                              value: n.id,
                            }))}
                            placeholder={
                              this.state.cafeId
                                ? this.props.cafeNamesList?.find(
                                  item => item.id === this.state.cafeId,
                                )?.name
                                : locales('fields.cafe.name')
                            }
                          />
                          <div className='invalid-feedback'>
                            {confirmCafeIdNotSelectedMessage}
                          </div>
                        </div>
                      )}
                    </ShowForPermission>
                  </div>
                </div>
                <div className='col-md-3 col-lg-3 col-sm-12'>
                  <div className='col-12 d-flex justify-content-center align-items-center p-2'>
                    <ImageUploader
                      name='avatarUrl'
                      id='avatarUrl'
                      placeholder={locales('labels.userProfile')}
                      actionUrl={`${API_ENDPOINT}/v1/general/upload-user-avatar`}
                      imageFile={this.state.avatarUrl}
                      isMulti={false}
                      onUploadSuccess={this.onUploadAvatarSuccess}
                      deleteImage={this.deleteAvatar}
                    />
                  </div>
                </div>
              </div>

              <div className='col-12 p-0'>
                <h6 className='line-container'>
                  <span className='line'>
                    <i className='fal fa-mobile px-1' />
                    {locales('titles.enterToApplication')}
                    <i className='fal fa-mobile px-1' />
                  </span>
                </h6>

                {this.props.location.editMode && (
                  <>
                    <div className='col-12 d-flex justify-content-start p-0 align-items-center my-4'>
                      <div className='col-6 p-0 d-flex'>
                        <label className='d-flex col-3' htmlFor='userName'>
                          {locales(
                            'labels.financial.transaction.userMobileNumber',
                          )}{' '}
                          :
                        </label>
                        <div>{userDetails.mobileNumber}</div>
                        <div className='invalid-feedback'>
                          {userNameInputInvalidMessage}
                        </div>
                      </div>
                    </div>

                    <div className='d-flex'>
                      <label className='d-flex px-3'>
                        {locales('messages.appPasswordSet')}
                      </label>
                      <Switch
                        enabled={false}
                        checked={this.props.userDetails.hasAppPassword}
                        name='isPasswordSet'
                        id='isPasswordSet'
                        onSwitchStateChanged={this.handleSwitchChange}
                      />
                    </div>
                  </>
                )}
              </div>

              <h6 className='line-container'>
                <span className='line'>
                  <i className='fal fa-columns px-1' />
                  {locales('titles.enterToPanel')}
                  <i className='fal fa-columns px-1' />
                </span>
              </h6>
              <div className='col-lg-9 col-md-9 col-sm-12 p-0'>
                <div className='row px-2 my-4'>
                  <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                    <label
                      className='rsee-form-label d-flex col-12'
                      htmlFor='userName'
                    >
                      {locales('messages.username')}
                    </label>
                    <input
                      type='text'
                      id='userName'
                      name='userName'
                      className={`form-control col-12 ${userNameInputValidStatus}`}
                      placeholder={locales('messages.username')}
                      maxLength={ENUMS.MAX_LENGTH.userName}
                    />
                    <small style={{ color: '#ccc' }}>
                      {locales('maxLength.15')}
                    </small>
                    <div className='invalid-feedback'>
                      {userNameInputInvalidMessage}
                    </div>
                  </div>

                  <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                    <label
                      className='rsee-form-label d-flex col-12'
                      htmlFor='mobileNumber'
                    >
                      {locales('fields.mobileNumber')}
                    </label>
                    <input
                      type='mobileNumber'
                      value={mobileNumber}
                      id='mobileNumber'
                      name='mobileNumber'
                      onChange={this.setMobileNumber}
                      className={`form-control col-12 ${mobileNumberInputValidStatus}`}
                      placeholder={locales('fields.mobileNumber')}
                      maxLength={ENUMS.MAX_LENGTH.mobileNumber}
                    />
                    <div className='invalid-feedback'>
                      {mobileNumberInputInvalidMessage}
                    </div>
                  </div>
                </div>

                <div className='row px-2 my-4'>
                  <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                    <label
                      className='rsee-form-label d-flex col-12'
                      htmlFor='panelPassword'
                    >
                      {locales('titles.newPassword')}
                    </label>
                    <input
                      type='password'
                      id='panelPassword'
                      name='panelPassword'
                      value={panelPassword}
                      disabled={this.props.location.editMode && checked}
                      className={`form-control col-12 ${panelPasswordInputValidStatus}`}
                      onChange={this.setPanelPassword}
                      placeholder={locales('titles.enterNewPassword')}
                      maxLength={ENUMS.MAX_LENGTH.password}
                    />
                    <small style={{ color: '#ccc' }}>
                      {locales('maxLength.15')}
                    </small>
                    <div className='invalid-feedback'>
                      {panelPasswordInputInvalidMessage}
                    </div>
                  </div>

                  <div className='col-lg-5 col-md-5 col-sm-12 p-0 m-1 required'>
                    <label
                      className='rsee-form-label d-flex col-12'
                      htmlFor='confirmPanelPassword'
                    >
                      {locales('titles.repatPassword')}
                    </label>
                    <input
                      type='password'
                      id='confirmPanelPassword'
                      value={confirmPanelPassword}
                      disabled={this.props.location.editMode && checked}
                      name='confirmPanelPassword'
                      className={`form-control col-12 ${confirmPanelPasswordInputValidStatus}`}
                      onChange={this.setConfirmPanelPassword}
                      placeholder={
                        locales('titles.reEnterPanelPassword') ||
                        'تکرار کلمه عبور'
                      }
                      maxLength={ENUMS.MAX_LENGTH.password}
                    />
                    <div className='invalid-feedback'>
                      {confirmPanelPasswordInputInvalidMessage}
                    </div>
                  </div>
                </div>

                <div className='row px-2 my-4'>
                  {this.props.location.editMode && (
                    <div className='col-6 justify-content-start d-flex p-0 required'>
                      <label className='rsee-form-label d-flex col-2 '>
                        {locales('messages.password')}
                      </label>
                      <label className='d-flex col-3'>
                        {locales('messages.isSetBefore')}
                      </label>
                      <Switch
                        enabled={enabled}
                        checked={checked}
                        name='isChangedPanelPassword'
                        id='isChangedPanelPassword'
                        onSwitchStateChanged={this.handleSwitchChange}
                      />
                      <label className='d-flex col-3 justify-content-center'>
                        {locales('messages.reset')}
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.userReducer.createNewUserLoading,
    error: state.userReducer.createNewUserError,
    failed: state.userReducer.createNewUserFailed,
    message: state.userReducer.createNewUserMessage,

    updateUserLoading: state.userReducer.updateUserLoading,
    updateUserError: state.userReducer.updateUserError,
    updateUserFailed: state.userReducer.updateUserFailed,
    updateUserMessage: state.userReducer.updateUserMessage,

    rolesLoading: state.rolesReducer.rolesLoading,
    rolesFailed: state.rolesReducer.rolesFailed,
    rolesError: state.rolesReducer.rolesError,
    rolesMessage: state.rolesReducer.rolesMessage,
    rolesList: state.rolesReducer.rolesList,
    roles: state.rolesReducer.roles,

    userDetailsLoading: state.userReducer.userDetailsLoading,
    userDetailsError: state.userReducer.userDetailsError,
    userDetailsFailed: state.userReducer.userDetailsFailed,
    userDetailsMessage: state.userReducer.userDetailsMessage,
    userDetails: state.userReducer.userDetails,

    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createNewUser: userObject =>
      dispatch(userActions.createNewUser(userObject)),
    fetchUserById: id => dispatch(userActions.fetchUserById(id)),
    updateUser: userObject => dispatch(userActions.updateUser(userObject)),
    fetchAllRoles: _ => dispatch(rolesActions.fetchAllRoles()),
    getAllCafeNamesForPanel: () =>
      dispatch(cafeActions.getAllCafeNamesForPanel()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOrEditUser);
